import { apiSlice } from './apiSlice';

export interface LoginResponse {
  accessToken: string;
  type: string;
}

interface LoginCredentials {
  email: string;
  password: string;
  panelType?: string;
}

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginCredentials>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
  }),
});

export const { useLoginMutation } = authApi;
